import React, { useEffect, useState } from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import { selectionTotal } from "./selection";
import NoticeTenantSummary from "./NoticeTenantSummary";
import LedgerDetails from "./LedgerDetails";
import RentDetails from "./RentDetails";

const money = (value) => value == null ? "—" : Number(value).toLocaleString("en-US", { style: "currency", currency: "USD" });

function useDetailRequest(url, tenantId, kind) {
  const [state, setState] = useState({ data: null, error: "" });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setState({ data: null, error: "" });
    http.get(url, { params: { tenantId } }).then((response) => {
      if (!active) return;
      if (response?.code !== "1" || (kind === "ledger" && !response.data)) {
        setState({ data: null, error: response?.msg || `Unable to load ${kind} details.` });
      } else setState({ data: response.data ?? [], error: "" });
    }).catch(() => active && setState({ data: null, error: `Unable to load ${kind} details. Please try again.` }));
    return () => { active = false; };
  }, [url, tenantId, kind, attempt]);
  return { ...state, retry: () => setAttempt((value) => value + 1) };
}

export default function TenantDetails({ tenant }) {
  const ledger = useDetailRequest(api.threeDayNoticeLedger, tenant.tenantId, "ledger");
  const rent = useDetailRequest(api.threeDayNoticeDetail, tenant.tenantId, "rent");
  return <div className="notice-combined-content">
    <NoticeTenantSummary tenant={tenant} />
    <div className="notice-detail-panels">
      <LedgerDetails ledger={ledger.data} error={ledger.error} onRetry={ledger.retry}
        amount={ledger.data ? money(ledger.data.endBalance) : "—"} />
      <RentDetails rows={rent.data} error={rent.error} onRetry={rent.retry}
        amount={rent.data ? money(selectionTotal(rent.data)) : "—"} />
    </div>
  </div>;
}
